import React from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import Loader from "../components/Loader";

interface ProtectedRouteProps {
  children?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, isInit } = useSelector(
    (state: RootState) => state.auth
  );

  if (isInit) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    localStorage.setItem("redirectTo", location.pathname);
    return <Navigate to="/signin" state={{ from: location }} />;
  }

  return <>{children || <Outlet />}</>;
};

export default ProtectedRoute;
